import { axiosConfig } from './axios-config.js'

export const website = {
  // 取得網站資訊
  get: (token) => axiosConfig.get('/api/console/web', token),

  // 更新網站資訊
  update: (data, token) => axiosConfig.post('/api/console/web', data, token)
}
